import { connect } from "react-redux";
import PostB2bAlliance from "./b2bAlliance";
import { bindActionCreators } from "redux";

import { getDropDownData, submitB2bData } from "services/redux/sales/postSales/b2bAlliance/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    dropDownData: state.postB2bReducer.dropDownData,
    allianceData: state.preB2bReducer.allianceData,
    documentUrlData: state.fileUploadReducer.documentUrlData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDropDownData,
            submitB2bData,
            documentUploadUrl,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PostB2bAlliance);
